import { Navigate, Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { hasTokens } from './tokenStorage';
import { useAuth } from './auth-context';

export function RequireAdmin() {
    const { t } = useTranslation();
    const { isAuthenticated, isAdmin } = useAuth();

    if (!hasTokens() || !isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    if (!isAdmin) {
        return <Navigate to="/login" replace state={{ error: t('auth.errors.adminRequired') }} />;
    }

    return <Outlet />;
}
